export default "__VITE_ASSET__titnBAI$__"